import React from 'react';
import { ClipboardList, UserCheck, Send } from 'lucide-react';
import { ABOUT_CARDS } from '../mock';

const ICONS = { ClipboardList, UserCheck, Send };

const AboutUs = () => (
  <section className="section" id="about" data-testid="about-section">
    <div className="container">
      <div className="section-title">
        <div className="eyebrow">About Us</div>
        <h2>Compatibility is a vibe, not a photo grid.</h2>
        <p>Krysha Love Station is a personalized, compatibility-based matchmaking platform — not a swipe machine. We read every answer, feel every vibe, and hand-pick people who actually fit.</p>
      </div>
      <div className="cards">
        {ABOUT_CARDS.map((c) => {
          const Ic = ICONS[c.icon];
          return (
            <div className="card" key={c.title}>
              <div className="icon"><Ic size={22} /></div>
              <div className="card-body">
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default AboutUs;
